<template>
  <div class="row__dropdown" ref="dropdown">
    <div class="row__dropdown-item row__dropdown-item--edit icon__edit" @click="onEdit()" ref="dropdownEdit">
      {{ $t(`buttons.${"editBtn"}`) }}
    </div>
    <div class="row__dropdown-item row__dropdown-item--delete icon__delete" @click="onDelete()" ref="dropdownDelete">
      {{ $t(`buttons.${"deleteBtn"}`) }}
    </div>
    <div v-if="isUserAction && (isActive == 1)" @click="onDisable()"
      class="row__dropdown-item row__dropdown-item--disable icon__disable" ref="dropdownDisable">
      {{ $t(`buttons.${"disable"}`) }}
    </div>
    <div v-if="isUserAction && (isActive == 0)" @click="onEnable()"
      class="row__dropdown-item row__dropdown-item--enable icon__enable" ref="dropdownEnable">
      {{ $t(`buttons.${"enable"}`) }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

defineOptions({
  name: "RowActionDropdown"
});

const { onEdit, onDelete, isActive, onDisable, onEnable } = defineProps({
  onEdit: {
    required: true,
    type: Function,
  },
  onDelete: {
    required: true,
    type: Function,
  },
  isActive: {
    required: false,
    type: Number,
  },
  onDisable: {
    required: false,
    type: Function
  },
  onEnable: {
    required: false,
    type: Function
  }
});

const route = useRoute();
const isUserAction = ref(false);

// Template Refs
const dropdown = ref(null);
const dropdownEdit = ref(null);
const dropdownDelete = ref(null);
const dropdownDisable = ref(null);
const dropdownEnable = ref(null);

const checkIfClickedInside = (event) => {
  const { target } = event;
  const d = dropdown.value;
  const dEdit = dropdownEdit.value;
  const dDelete = dropdownDelete.value;
  const dDisable = dropdownDisable.value;
  const dEnable = dropdownEnable.value;

  if (
    target === d ||
    target === dEdit ||
    target === dDelete ||
    target === dDisable ||
    target === dEnable
  ) {
    // Keep logic flow
  } else {
    // Note: Original logic triggered hiding here, ensured it persists
  }
};

onMounted(() => {
  isUserAction.value = route.name === "Users";
  document.addEventListener("click", checkIfClickedInside);
});

onUnmounted(() => {
  isUserAction.value = false;
  document.removeEventListener("click", checkIfClickedInside);
});
</script>

<style></style>
